<template>
  <div class="base-form">
    <el-form :model="forms" :rules="rules" ref="form">
      <slot></slot>
    </el-form>  
  </div>
</template>

<script>
export default {
  name: "BaseDialog",
  props: {
    forms: {
      type: Object,
      required: true
    },
    rules: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      num: 50,
      props: {}
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="stylus">
.base-form{
  .el-form-item__content{
    width 500px;
    display flex;
    align-items: center;
  }
  .base-form{
    padding:0 80px;
  }
  .el-upload {
    margin-left: -10px!important;
  }
  .el-form-item{
    display:flex;
    margin-bottom: 14px;
    .el-form-item__label{
      flex:1;
      margin-right:34px;
      font-size:16px;
      text-align:right;
      color:#606266;
    }
  }
  .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
    left:-15px;
    font-size :18px;
    color:#fe3223;
  }
  .el-input__inner{
    width:500px;
    height:38px;
    border:1px solid #e0e0e0;
    line-height :38px;
  }
  .el-input{
    margin-left:-10px;
  }
  .dialog-footer{
    margin-top:30px;
    padding-left:120px;
  }
  .el-button{
    width:100px;
    height:40px;
    margin-left:-9px;
    font-size:16px;
  }
  .el-button--primary{
    margin-left:25px;
    background:#3389ff;
  }
  .el-button--primary:focus, .el-button--primary:hover {
    background:#3389ff;
    border-color: #66b1ff;
    color: #fff;
  }
  // .el-button:focus, .el-button:hover {
  //   color: initial;
  //   background-color: initial;
  // }
  // .cultureBreed .el-dialog .el-button--primary {
  //   background: #3389ff;
  // }
  
  ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color:#999;
    font-size :14px;
  }
  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color:#999;
    font-size :14px;
  }
  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color:#999;
    font-size :14px;
  }
  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color:#999;
    font-size :14px;
  }
}

</style>
